/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path hooks
 * @description Halps creating links inside the application
 * Hook for creating links inside the app
 *
 * @evaluation good
 * @category simple ui
 *
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { useAppContext } from "./../context/AppCtxProvider";
const useCreateLink = () => {
  const appCtx = useAppContext();
  let wfperiod = new URLSearchParams(useLocation().search).get("wfperiod");
  const cb = React.useCallback(
    (params: {
      page?: string;
      meaId?: string;
      period?: string;
      parentId?: string;
    }) => {
      let link = `${appCtx.rootUrl}/${params.page || appCtx.page}`;
      if (params.parentId) {
        return `${link}/${params.parentId}`;
      }
      link += `/${params.meaId || appCtx.elementId || ""}${
        params.period || appCtx.originalPeriod
          ? `?period=${params.period || appCtx.originalPeriod}`
          : ""
      }`;
      link += wfperiod
        ? `${
            params.period || appCtx.originalPeriod ? "&" : "?"
          }wfperiod=${wfperiod}`
        : ``;
      return link;
    },
    [appCtx.rootUrl, appCtx.elementId, appCtx.page, appCtx.originalPeriod]
  );
  return cb;
};
export default useCreateLink;
